<ul class="list-unstyled bottom-menu">
  <li style="position: relative;">
    <a [routerLink]="['/karpooshe']" [ngClass] = "{active: activeMenu === 'karpooshe'}" >
      <img *ngIf="activeMenu !== 'karpooshe'" src="assets/img/karpoosheh.svg" alt="">
      <img *ngIf="activeMenu === 'karpooshe'" src="assets/img/karpoosheh-active.svg" alt="">
      <span>کارپوشه</span>
      <span class="underLine"></span>
      <span *ngIf="newOne" class="notification"></span>
    </a>
  </li>
  <li (click) = "showPopUp()">
    <a [ngClass] = "{active: activeMenu === 'financial'}"
       class="disabled">
      <img *ngIf="activeMenu !== 'financial'"  src="assets/img/financial.svg" alt="">
      <img *ngIf="activeMenu === 'financial'"  src="assets/img/financial-active.svg" alt="">
      <span>مدیریت مالی </span>
      <span class="underLine"></span>
    </a>
  </li>
  <li (click)="chequeButtonAction()">
    <a [ngClass] = "{active: activeMenu === 'cheque'}" >
      <img *ngIf="activeMenu !== 'cheque'"  src= "assets/img/cheque.svg" alt="">
      <img *ngIf="activeMenu === 'cheque'"  src= "assets/img/cheque-active.svg" alt="">
      <span>مدیریت چک</span>
      <span class="underLine"></span>
    </a>
  </li>
  <li>
    <a [routerLink]="['/cards']" [ngClass] = "{active: activeMenu === 'cards'}">
      <img *ngIf="activeMenu !== 'cards'"  src="assets/img/cards.svg" alt="">
      <img *ngIf="activeMenu === 'cards'"  src="assets/img/Cards-active.svg" alt="">
      <span>کارت‌هــا</span>
      <span class="underLine"></span>
    </a>
  </li>
  <li>
    <a [routerLink]="['/deposits']" [ngClass] = "{active: activeMenu === 'deposits'}">
      <img *ngIf="activeMenu !== 'deposits'"  src="assets/img/sepordeha.svg" alt="">
      <img *ngIf="activeMenu === 'deposits'"  src="assets/img/sepordeha-active.svg" alt="">
      <span>سپرده‌هــا</span>
      <span class="underLine"></span>
    </a>
  </li>
</ul>
